import { render } from "./Cleric.vue?vue&type=template&id=fb2e233a&scoped=true&ts=true"
import script from "./Cleric.vue?vue&type=script&lang=ts"
export * from "./Cleric.vue?vue&type=script&lang=ts"

import "./Cleric.vue?vue&type=style&index=0&id=fb2e233a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2e233a"]])

export default __exports__